module.exports = __webpack_public_path__ + "img/fly zipper length.2649582c.png";